var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {}
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }
import React from 'react'
import classNames from 'classnames'
export var ODInputGuideText = function (props) {
  var _a = props.text,
    text = _a === void 0 ? '\u00a0\u00a0' : _a,
    cnProps = __rest(props, ['text'])
  var cn = classNames('w-full', 'od-guide-text', cnProps)
  return React.createElement('div', { className: cn }, text)
}
//# sourceMappingURL=ODInputGuideText.js.map
